import dayjs from 'dayjs';
import Cookie from 'js-cookie';
import { AuthenticatorAPI } from 'services/api';
import GaEventManager from 'services/ga';
import { history } from 'state/store';

export class Authenticator extends AuthenticatorAPI {
  public static async handleAutoLogin() {
    const params = new URLSearchParams(window.location.search);
    const usedAutoLogin = Cookie.get('autoLogin');

    if (params.has('token') && usedAutoLogin !== 'true') {
      const token = params.get('token');
      try {
        await this.autoLogin(token);
      } catch (error) {
        window.rollbar?.error(
          'BuyersPortal: auto login failed',
          error as Error,
          `Access token: ${token}`,
        );
      }
      const expiration = dayjs().add(30, 'days').toDate();
      Cookie.set('autoLogin', 'true', { expires: expiration });
    }
  }

  public static async handleCircaAutoLogin() {
    // sample URL that Circa will use to redirect back to our app
    // http://localapp.worthy.com:5000/tenders?circa_auth_token=123
    const params = new URLSearchParams(window.location.search);

    if (params.has('circa_auth_token')) {
      const token = params.get('circa_auth_token');
      params.delete('circa_auth_token');
      history.replace({
        pathname: '/tenders',
        search: params.toString(),
      });
      try {
        await this.circaAutoLogin(token);
      } catch (error) {
        window.rollbar?.error(
          'BuyersPortal: auto login failed',
          error as Error,
          `Access token: ${token}`,
        );
      }
    }
  }

  public static async login(email: string, password: string) {
    try {
      const response = super.login(email, password);

      GaEventManager.GA4LoginEvent('password', 'success');

      return response;
    } catch (error) {
      GaEventManager.GA4LoginEvent('password', 'failure');

      throw error;
    }
  }

  public static async otpLogin(
    email: string,
    code: string,
    medium: 'email' | 'sms',
    requestId?: string,
  ) {
    try {
      const response = await super.otpLogin(email, code, medium, requestId);

      GaEventManager.GA4LoginEvent(medium === 'sms' ? 'otpSMS' : 'otpEmail', 'success');

      return response;
    } catch (error) {
      GaEventManager.GA4LoginEvent(medium === 'sms' ? 'otpSMS' : 'otpEmail', 'failure');

      throw error;
    }
  }
}
